module.exports = __webpack_public_path__ + "img/INSIGHTS.99833de3.png";